module.exports = __webpack_public_path__ + "img/processing_file.8f1357c9.svg";